<template>

  <div>
            <br>
            <br>
			<el-form :model="Form" :label-position="labelPosition"  :rules="FormRules" ref="Form">
				<el-form-item label="负责人姓名" prop="Name" >
					<el-input v-model="Form.Name" auto-complete="off"></el-input>
				</el-form-item>			
				<el-form-item label="性别" prop="Sex">
					<el-radio-group v-model="Form.Sex" >
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>	
            <el-form-item label="负责人手机" prop="Phone" >
					<el-input  v-model="Form.Phone" auto-complete="off"></el-input>
				</el-form-item>                
        	<el-form-item label="负责人邮箱" prop="Email">
					<el-input   v-model="Form.Email" auto-complete="off"></el-input>
				</el-form-item>                        
				<el-form-item label="备注">
					<el-input type="textarea" v-model="Form.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
			</div>
</div>
</template>

<script>
	import {mapGetters} from 'vuex';
   import {GetLeaderInfo,EditLeaderInfo} from  '../../api/api';
  export default {
    data(){
      return{

      				
        // addFormVisible: true,//新增界面是否显示
				addLoading: false,
			
				FormRules: {
		  Name: [
						{ required: true, message: '请输入名字', trigger: 'blur' }
          ],
          Phone:[
            
          {required:true,message:'请输入手机号',trigger: 'blur'}
            
          ],
          Email:[
            
          {required:true,message:'请输入邮箱',trigger: 'blur'}
            
          ],         
				},
				labelPosition: 'top',
				Form: {		

                },
      }
    },
 

   
   methods: {
      handleChange(value) {
        console.log(value);
      },
    	 
		 ...mapGetters(['getuserstate']),
        //显示新增界面
	   GetInfo:function(){
					let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						// TenancyId:TenancyId
					}
           GetLeaderInfo(para).then((res)=>{
						 let { Success,Msg } = res.data;
						 if(Success){
                         this.Form=res.data.Data;

						 }
						//  let list=res.data;
					 })
		 },
     editSubmit: function () {
				this.$refs.Form.validate((valid) => {
					if (valid) {

						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							 if(!(/^1[3456789]\d{9}$/.test(this.Form.Phone)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }                           
							this.addLoading = true;
							//NProgress.start();
                            let para = Object.assign({}, this.Form);
							EditLeaderInfo(para).then((res) => {
								this.addLoading = false;
                                //NProgress.done();
 								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									this.Form=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
                                    });
								}

								
							}) .catch(error=>{
             alert('系统错误');
            });
						});
					}
				});
			}
			 },
			 mounted() {
			this.GetInfo();
		}


	}

</script>


// WEBPACK FOOTER //
// TeamLeader.vue?f356a6fe